import * as Config from '../../../config';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import { connect } from "react-redux";

// Used for sortable list
function ConnectedMidDropBox({ accept, style, drop, idParent, backend, boundaries }) {
  const [{ isOver, canDrop }, refDrop] = useDrop({
    accept,
    drop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })
  const opacity = (isOver) ? 1 : 0;

  useEffect(() => { // TOUCH BACKEND
    if (backend === `touch`) {
      if (canDrop && boundaries && window.currentListDrag !== idParent) {
        if (window.currentListDrag && document.getElementById(`FSL-${window.currentListDrag}`)) {
          document.getElementById(`FSL-${window.currentListDrag}`).removeEventListener(`mousemove`, window.customScroll)
        }
        window.currentListDrag = idParent;
        window.customScroll = Config.customScroll(`FSL-${idParent}`, boundaries.t, boundaries.bottom);
        document.getElementById(`FSL-${idParent}`).addEventListener(`mousemove`, window.customScroll)
      }

      if (!canDrop && window.currentListDrag === idParent) {
        window.currentListDrag = null;
        document.getElementById(`FSL-${idParent}`).removeEventListener(`mousemove`, window.customScroll)
        window.clearInterval(window.scrollUp);
        window.scrollUp = null;
        window.clearInterval(window.scrollDown);
        window.scrollDown = null;
      }
    }
  }, [backend, canDrop, boundaries, idParent])

  return <div ref={refDrop} className={`mid-drop-box`} style={{...style, opacity}} />
}

ConnectedMidDropBox.propTypes = {
  accept: PropTypes.any.isRequired,
  style: PropTypes.object,
  drop: PropTypes.func.isRequired,
  idParent: PropTypes.any,
  backend: PropTypes.string
}

const MidDropBox = connect(
  state => ({
    backend: state.backend,
    boundaries: state.currentListBoundaries
  })
)(ConnectedMidDropBox);

export default MidDropBox;
